import { Navigate } from 'react-router-dom';
import { useGetSettingMenu } from 'src/api/menu_api';
import { PATHS } from 'src/routes/paths';
import { findSettingsMenuItem } from 'src/sections/settings/settings_menu';

export default function SettingsGuard({ menuKey, children }) {
  const { searchResults, isSettingAccess, searchLoading } = useGetSettingMenu();

  if (searchLoading) {
    return null;
  }

  if (!isSettingAccess || !findSettingsMenuItem(searchResults, menuKey)) {
    return (
      <Navigate
        to={PATHS.dashboard.root}
        replace
      />
    );
  }

  return <>{children}</>;
}
